import getApiClient from '@/plugins/api-client'

export default {
    loadCurrentData: function() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('terms/latest')
            .then((result) => {
                self.terms = result.data['hydra:member'][0]
            })
            .catch(() => {})
    },

    updateTerms: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.post('terms', {
            content: self.terms.content
        })
            .then((result) => {
                self.terms = result.data
                self.success = true
            })
            .catch((error) => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }

            })
    },

    resetFormResult: function() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    }
}
